export default {
    computed: {
        years() {
            return this.$store.state.vehicle_years.data;
        },
        yearValues() {
            return this.years.map((year) => parseInt(year.name))
        },
        minYear() {
            return Math.min(...this.yearValues);
        },
        maxYear() {
            return Math.max(...this.yearValues);
        }
    },
}
